import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { NAV } from "@/data/content";

export const Logo = ({ size = 40 }) => (
  <img src="/images/logo.jpg" alt="Elite Performance Lab" width={size} height={size} className="rounded-full ring-1 ring-white/15" />
);

export const Header = ({ onRegister }) => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  return (
    <header
      data-testid="site-header"
      className="fixed top-3 inset-x-0 z-50 px-3 sm:px-4"
    >
      <div className={`max-w-[1400px] mx-auto pl-2 pr-2 h-16 flex items-center justify-between rounded-full border transition-colors duration-300 ${scrolled ? "bg-[#070a11]/75 backdrop-blur-xl border-white/10" : "bg-white/[0.04] backdrop-blur-md border-white/5"}`}>
        <a href="#top" className="flex items-center gap-3" data-testid="header-logo-link">
          <Logo />
          <span className="font-display font-bold tracking-tight text-[15px] leading-[1.05] hidden sm:block">
            Elite<br />Performance Lab
          </span>
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <a key={n.id} href={`#${n.id}`} data-testid={`nav-${n.id}-link`} className="text-sm font-medium text-slate-300 hover:text-white transition-colors">
              {n.label}
            </a>
          ))}
        </nav>
        <button onClick={onRegister} className="btn-primary !py-2.5 !px-5" data-testid="header-register-button">Register Now</button>
      </div>
    </header>
  );
};
